import { Typography } from '@mui/material';
import Flex from 'src/Components/Bases/Flex';

const PoliciesContent = () => {
  return (
    <Flex flexDirection={'column'} gap={1}>
      <Typography variant="subtitle2">ข้อตกลงและเงื่อนไขการใช้งาน</Typography>
      <Flex
        height={500}
        overflow={'hidden'}
        gap={1}
        sx={{ overflowY: 'auto' }}
        flexDirection={'column'}
      >
        <Typography>
          1. บริษัทจดทะเบียนรับทราบและตกลงว่า ฟังก์ชัน Corporate Value Up
          Platform
          เป็นฟังก์ชันที่ตลาดหลักทรัพย์จัดให้มีขึ้นเพื่อให้บริษัทจดทะเบียนใช้เพื่อวัตถุประสงค์ที่เกี่ยวข้องกับการจัดทำแผนและเป้าหมายการเพิ่มมูลค่าบริษัทตามแนวทางด้านสิ่งแวดล้อม
          (Environment) สังคม (Social) และธรรมาภิบาล (Governance) (“Corporate
          Value Up Plan”)
          ของบริษัทจดทะเบียนและบริษัทจดทะเบียนรับรองว่าจะใช้บริการฟังก์ชัน
          Corporate Value Up Platform เพื่อวัตถุประสงค์ที่เกี่ยวข้องกับการจัดทำ
          Corporate Value Up Plan ของบริษัทจดทะเบียนเท่านั้น
        </Typography>
        <Typography>
          2. บริษัทจดทะเบียนรับทราบและตกลงว่า
          ตลาดหลักทรัพย์ไม่ได้รับรองว่าข้อมูลที่เกิดจากการประมวลข้อมูลที่บริษัทจดทะเบียนได้กรอกหรือบันทึกผ่านฟังก์ชัน
          Corporate Value Up Platform
          จะมีความครบถ้วนหรือถูกต้องหรือปราศจากความผิดพลาดใด ๆ
          และบริษัทจดทะเบียนมีหน้าที่ในการตรวจสอบความครบถ้วนหรือถูกต้องของข้อมูลจากการประมวลดังกล่าวทุกครั้ง
        </Typography>
        <Typography>
          3. บริษัทจดทะเบียนรับรองว่า ข้อความ รูปภาพ ตารางข้อมูล กราฟ กราฟิกต่าง
          ๆ เสียง และข้อมูลอื่น ๆ ไม่ว่าจะอยู่ในรูปแบบใด ที่บริษัทจดทะเบียน
          บันทึก อัปโหลด (Upload) หรือนำมาใช้บนฟังก์ชัน Corporate Value Up
          Platform (“ข้อมูลของบริษัทจดทะเบียน”)
          เป็นลิขสิทธิ์และทรัพย์สินทางปัญญาของบริษัทจดทะเบียนและ/หรือผู้ให้อนุญาตแก่บริษัทจดทะเบียน
          หากในระหว่างระยะเวลาการใช้บริการฟังก์ชัน Corporate Value Up Platform
          หรือเมื่อการใช้บริการฟังก์ชัน Corporate Value Up Platform สิ้นสุดลง
          ไม่ว่าด้วยเหตุใดก็ตาม มีบุคคลภายนอกกล่าวอ้างหรือใช้สิทธิเรียกร้องใด ๆ
          ว่ามีการละเมิดลิขสิทธิ์หรือทรัพย์สินทางปัญญาเกี่ยวกับข้อมูลของบริษัทจดทะเบียน
          บริษัทจดทะเบียนตกลงแจ้งให้ตลาดหลักทรัพย์ทราบภายใน 7 (เจ็ด) วัน
          นับแต่วันที่บริษัทจดทะเบียนทราบเรื่องดังกล่าว
          โดยบริษัทจดทะเบียนต้องดำเนินการทั้งปวงเพื่อให้การกล่าวอ้างหรือเรียกร้องดังกล่าวระงับสิ้นไปโดยเร็ว
          หากตลาดหลักทรัพย์ต้องรับผิดชดใช้ค่าเสียหายแก่บุคคลภายนอก
          เนื่องจากผลแห่งการละเมิดลิขสิทธิ์หรือทรัพย์สินทางปัญญาดังกล่าว
          บริษัทจดทะเบียนจะเป็นผู้ชดใช้ค่าเสียหาย ค่าปรับ ค่าใช้จ่าย รวมทั้ง
          ค่าฤชาธรรมเนียมและค่าทนายความทั้งหมดแต่เพียงผู้เดียว ทั้งนี้
          ให้หน้าที่และภาระผูกพันในการปกป้องความเสียหายนี้มีผลใช้บังคับต่อไปแม้ว่าการใช้บริการฟังก์ชัน
          Corporate Value Up Platform นี้สิ้นสุดลงแล้วก็ตาม
        </Typography>
        <Typography>
          4. บริษัทจดทะเบียนรับทราบและตกลงว่า ฟังก์ชัน Corporate Value Up
          Platform อาจมีการเชื่อมโยงกับฟังก์ชันอื่นในระบบ SETLink
          ระบบงานอื่นของตลาดหลักทรัพย์ และ/หรือระบบงานของบุคคลอื่น
          ซึ่งเป็นไปเพื่ออำนวยความสะดวกแก่บริษัทจดทะเบียนเท่านั้น
          โดยบริษัทจดทะเบียนรับทราบและตกลงว่า
          ตลาดหลักทรัพย์ไม่ได้รับรองว่าข้อมูลของบริษัทจดทะเบียนที่เชื่อมโยงดังกล่าวครบถ้วนหรือถูกต้อง
          และบริษัทจดทะเบียนมีหน้าที่ในการตรวจสอบข้อมูลดังกล่าวทุกครั้ง
          นอกจากนี้
          บริษัทจดทะเบียนรับทราบและตกลงตามข้อจำกัดและเงื่อนไขของการเชื่อมโยงข้อมูลจากฟังก์ชัน
          Corporate Value Up Platform ดังนี้
        </Typography>
        <Typography ml={6}>
          4.1 การเชื่อมโยงข้อมูลจากฟังก์ชัน Corporate Value Up Platform
          ไปยังฟังก์ชันอื่นในระบบ SETLink และระบบงานอื่นของตลาดหลักทรัพย์:
          บริษัทจดทะเบียนรับทราบและตกลงว่าบริษัทจดทะเบียนยังมีหน้าที่ในการปฏิบัติตามข้อตกลงเกี่ยวกับฟังก์ชันการใช้งานและระบบงานอื่นของตลาดหลักทรัพย์
          ที่ได้เชื่อมโยงข้อมูลนั้นด้วย
        </Typography>
        <Typography ml={6}>
          4.2 การเชื่อมโยงข้อมูลจากฟังก์ชัน Corporate Value Up Platform
          ไปยังระบบงานของบุคคลอื่น : บริษัทจดทะเบียนรับทราบและตกลงว่า
          ระบบงานที่เชื่อมโยงนี้มิได้แสดงว่าได้รับการสนับสนุนหรืออยู่ภายใต้การควบคุม
          หรือความรับผิดชอบของตลาดหลักทรัพย์ ดังนั้น
          ตลาดหลักทรัพย์จึงไม่อาจให้การรับรองในความถูกต้อง ความน่าเชื่อถือ
          หรือความปลอดภัยของระบบงานที่เชื่อมโยง และจะไม่มีความรับผิด
          ในความสูญหายหรือเสียหายใด ๆ
          ที่บริษัทจดทะเบียนได้รับจากการใช้งานหรือเชื่อมโยงระบบงานดังกล่าว
          และขอให้บริษัทจดทะเบียนโปรดศึกษาข้อตกลงและเงื่อนไขการใช้งาน
          ของระบบงานที่เชื่อมโยงแต่ละแห่งนั้นด้วย
        </Typography>
        <Typography>
          5. บริษัทจดทะเบียนตกลงจะไม่ใช้บริการฟังก์ชัน Corporate Value Up
          Platform ในลักษณะที่เป็นการขัดต่อกฎหมาย
          หรือก่อให้เกิดความเดือดร้อนรำคาญ
          หรือเป็นการก่อกวนการทำงานหรืออาจทำให้เกิดผลกระทบต่อความน่าเชื่อถือของระบบ
          SETLink หรือระบบใด ๆ ของตลาดหลักทรัพย์หรือบุคคลอื่น
          หรือใช้บริการฟังก์ชัน Corporate Value Up Platform
          เพื่อการอื่นนอกจากเพื่อวัตถุประสงค์ที่เกี่ยวข้องกับการจัดทำ Corporate
          Value Up Plan ของบริษัทจดทะเบียน หรือไม่ปฏิบัติตามหรือปฏิบัติ
          ฝ่าฝืนข้อตกลงและเงื่อนไขการใช้บริการฟังก์ชัน Corporate Value Up
          Platform นี้
        </Typography>
        <Typography>
          6. บริษัทจดทะเบียนตกลงปกป้องตลาดหลักทรัพย์จากความเสียหายใด ๆ
          อันเกิดจากการใช้บริการฟังก์ชัน Corporate Value Up Platform
          และ/หรือข้อมูลของบริษัทจดทะเบียนที่อัปโหลด (Upload)
          หรือนำมาใช้บนฟังก์ชัน Corporate Value Up Platform
          ในกรณีที่เกิดความเสียหายใด ๆ
          ขึ้นกับตลาดหลักทรัพย์หรือบุคคลอื่นใดจากการกระทำดังกล่าว
          บริษัทจดทะเบียนตกลงชดใช้ค่าเสียหายที่เกิดขึ้นแก่ตลาดหลักทรัพย์จนครบถ้วน
          ซึ่งรวมถึงค่าทนายความด้วย นอกจากนี้ บริษัทจดทะเบียนรับทราบและตกลงว่า
          ตลาดหลักทรัพย์จะไม่เข้าถึงข้อมูลของบริษัทจดทะเบียน
          เว้นแต่ในกรณีที่ตลาดหลักทรัพย์มีเหตุอันควรสงสัยหรือตรวจพบว่าบริษัทจดทะเบียนกระทำการใด
          ๆ ที่มีลักษณะเข้าข่ายเป็นการกระทำตามข้อ 5
          ซึ่งตลาดหลักทรัพย์อาจเข้าตรวจสอบข้อมูลของบริษัทจดทะเบียน
          ตลอดจนระงับหรือยกเลิกการให้บริการฟังก์ชัน Corporate Value Up Platform
          แก่บริษัทจดทะเบียนทันที โดยไม่ต้องแจ้งให้บริษัทจดทะเบียนทราบล่วงหน้า
          โดยบริษัทจดทะเบียนตกลงจะไม่โต้แย้งหรือเรียกร้องให้ตลาดหลักทรัพย์รับผิดชอบชดใช้ค่าเสียหายที่เกิดขึ้นแก่บริษัทจดทะเบียนไม่ว่าในกรณีใด
          ๆ และในกรณีที่ตลาดหลักทรัพย์ระงับหรือยกเลิกการให้บริการฟังก์ชัน
          Corporate Value Up Platform แก่บริษัทจดทะเบียนด้วยเหตุตามข้อ 6 นี้
          หากมี ความเสียหายใด ๆ เกิดขึ้นกับตลาดหลักทรัพย์
          บริษัทจดทะเบียนตกลงชดใช้ค่าเสียหายให้ตลาดหลักทรัพย์จนครบถ้วน ทั้งนี้
          ให้หน้าที่และภาระผูกพันในการปกป้องความเสียหายนี้มีผลใช้บังคับต่อไปแม้ว่าการใช้บริการฟังก์ชัน
          Corporate Value Up Platform นี้สิ้นสุดลงแล้วก็ตาม
        </Typography>
        <Typography>
          7.
          ตลาดหลักทรัพย์จะดำเนินการอย่างเหมาะสมเพื่อให้การเข้าถึงและการใช้งานฟังก์ชัน
          Corporate Value Up Platform นี้เป็นไปอย่างต่อเนื่อง
          ไม่หยุดชะงักและจะจัดให้มีระบบป้องกันการเข้าถึงข้อมูลใด ๆ
          จากบุคคลที่ไม่ใช่ บริษัทจดทะเบียนหรือผู้ใช้งานของบริษัทจดทะเบียน
          อย่างไรก็ดี ตลาดหลักทรัพย์ไม่อาจรับรองได้ว่า การเข้าใช้งานฟังก์ชัน
          Corporate Value Up Platform จะเป็นไปอย่างต่อเนื่อง ไม่หยุดชะงัก
          หรือปราศจากความล่าช้าหรือข้อบกพร่องใด ๆ และไม่อาจรับรองว่าฟังก์ชัน
          Corporate Value Up Platform นี้จะปราศจากโปรแกรม ไฟล์
          หรือซอฟต์แวร์ที่มีจุดประสงค์มุ่งร้าย
          หรืออาจสร้างความเสียหายหรือสูญหายต่อระบบหรือข้อมูลของบริษัทจดทะเบียน
          อาทิ ไวรัส คอมพิวเตอร์เวิร์ม โทรจันฮอร์ส สปายแวร์
          หรือไฟล์ซึ่งเป็นอันตรายอื่น ๆ (รวมเรียกว่า “ความบกพร่อง”) ทั้งนี้
          ไม่ว่าความบกพร่องดังกล่าวจะเกิดขึ้นจากบุคคล หรือความขัดข้องทางเทคนิค
          หรือเหตุสุดวิสัยอย่างอื่น ดังนั้น
          บริษัทจดทะเบียนจึงรับทราบเงื่อนไขดังกล่าวและตกลงว่าในกรณีที่มี
          ความบกพร่องใด ๆ เกิดขึ้น ตลาดหลักทรัพย์จะไม่รับผิดชอบในความสูญหาย
          ความเสียหาย ค่าสินไหมทดแทน ค่าใช้จ่าย หรือค่าเสียหายใด ๆ
          ที่เกิดจากหรือเป็นผลสืบเนื่องมาจากความบกพร่องเหล่านั้นในทุกกรณี
        </Typography>
        <Typography>
          8. บริษัทจดทะเบียนรับทราบและตกลงว่าข้อตกลงและเงื่อนไขการใช้งานฟังก์ชัน
          Corporate Value Up Platform
          เป็นส่วนหนึ่งของข้อตกลงและเงื่อนไขการใช้งานบริการระบบ SETLink ดังนั้น
          ในการใช้งานฟังก์ชัน Corporate Value Up Platform
          บริษัทจดทะเบียนตกลงผูกพันตามข้อตกลงและเงื่อนไขการใช้งานบริการระบบ
          SETLink ด้วย
        </Typography>
      </Flex>
    </Flex>
  );
};

export default PoliciesContent;
